/**
 * The sandbox pass: on test.playpop.tv, QR codes shown on the TV carry it, so
 * a phone that scans one is let straight in without typing the password.
 * Elsewhere there's no gate and no pass.
 */
let pending = null;
export function sandboxPass() {
    pending ??= fetch("/api/gate/pass", { cache: "no-store" })
        .then((r) => (r.ok ? r.json() : { pass: null }))
        .then((b) => {
        if (b.pass)
            rememberPass(b.pass);
        return b.pass ?? null;
    })
        .catch(() => null);
    return pending;
}
const PASS_KEY = "playpop.pass";
/**
 * Keep the sandbox pass on this device, so the game connection can show it
 * even if the browser drops its cookie (an in-app browser, or a page reloaded
 * after the camera).
 */
export function rememberPass(pass) {
    try {
        localStorage.setItem(PASS_KEY, pass);
    }
    catch {
        /* private mode: the cookie still works */
    }
}
export function savedPass() {
    try {
        return localStorage.getItem(PASS_KEY);
    }
    catch {
        return null;
    }
}
/** A link with the pass added, if there is one. */
export function withPass(url, pass) {
    if (!pass)
        return url;
    const u = new URL(url, location.origin);
    u.searchParams.set("pass", pass);
    return u.toString();
}
//# sourceMappingURL=pass.js.map